module.exports = __webpack_public_path__ + "img/lang-EN.0a47bc05.svg";